import useAuth from 'context/Auth';
import { LEND_EVENTS_QUERY } from 'graphql/lend/lendEventsQuery';
import { useSuperGraphApi } from 'hooks/api/graphql/supergraph';
import { DEBT_TICKER } from 'pages/lend/utils';
import { STATUS_FILTER } from 'pages/property/components/PropertyActivities/components/PropertyActivityList/hooks/useFetchPropertyActivityList';
import { useEffect } from 'react';
import { GraphqlEdge } from 'types/graphql-types';

const PAGE_SIZE = 15;

const useFinancingActivityPreviewFetcher = () => {
  const [request, { data, loading }] = useSuperGraphApi(LEND_EVENTS_QUERY);
  const { isLoggedIn } = useAuth();
  const manipulatedData = data?.events?.edges?.map(
    (item: GraphqlEdge) => item.node
  );

  useEffect(() => {
    request({
      variables: {
        pageSize: PAGE_SIZE,
        pageNumber: 1,
        filter: JSON.stringify({
          property_ticker: DEBT_TICKER,
          ...STATUS_FILTER,
        }),
      },
    });
  }, [isLoggedIn]);

  return {
    data: manipulatedData,
    loading: loading && isLoggedIn,
  };
};

export default useFinancingActivityPreviewFetcher;
